import { render, staticRenderFns } from "./HistoricoRemanejamento.vue?vue&type=template&id=7208ebf4"
import script from "./HistoricoRemanejamento.vue?vue&type=script&lang=js"
export * from "./HistoricoRemanejamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports